import mainHTTPClient from '../clients/mainHTTPClient'
import { MAIN_HTTP_API_ENDPOINTS } from '../constants/api/mainHttp'

/**
 * Search for UserActionTypes.
 * @param listMetaData {ListMetaData}
 * @returns {Promise<AxiosResponse<object[]>>}
 * @constructor
 */
const FindMany = listMetaData => mainHTTPClient.get(
  MAIN_HTTP_API_ENDPOINTS.USER_ACTION_TYPES,
  {
    ...listMetaData.toAxiosRequestParams()
  }
)

const UserActionTypeService = {
  FindMany
}

export default UserActionTypeService
